module.exports = __webpack_public_path__ + "main/images/shared/fuel-your-mind@2x.16fdf67a9b64101db5975017cd926b6b.png";